import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=2405c02a&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=2405c02a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405c02a",
  null
  
)

export default component.exports